import React from 'react';
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { ErrorContext } from '../../contexts/ErrorContext';

const ErrorNotification = () => {
    const { displayError, setDisplayError, errorMessage, errorDuration, type } = React.useContext(ErrorContext);

    const handleClose = () => {
        setDisplayError(false);
    };

    React.useEffect(() => {
        let timer;
        if (displayError) {
            setTimeout(() => {
                setDisplayError(false);
            }, errorDuration);
        }

        return () => clearTimeout(timer);
    }, [displayError]);

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={displayError}
            // autoHideDuration={errorDuration}
            onClose={handleClose}
        >
            <Alert 
                onClose={handleClose} 
                severity={type}
                variant='filled'
                sx={{ width: '100%' }}
            >
                {errorMessage}
            </Alert>
        </Snackbar>
    );
}

export default ErrorNotification;